const STOP_SPEAKING_ACTIVITY = 'WEB_CHAT/STOP_SPEAKING';

export default function stopSpeakingActivity() {
  return {
    type: STOP_SPEAKING_ACTIVITY
  };
}

export { STOP_SPEAKING_ACTIVITY };
